<template>
<div class="container">
  <h6 class="s-title s-title__small">请完善你信息</h6>
  <div class="s-card">
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>品牌名称</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写品牌名称" class="s-input" v-model="info.brandName">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>活动名称</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写活动名称" class="s-input" v-model="info.name">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>粉丝量要求</label>
      <div class="s-form-controller">
        <input type="number" placeholder="请填写粉丝量最低要求" class="s-input" v-model="info.requiredFansCount" >~
        <input type="number" placeholder="请填写粉丝量最高要求" class="s-input" v-model="info.maxFansCount" >
        万人
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>需要达到人数</label>
      <div class="s-form-controller">
        <input type="number" placeholder="请填写需要的活动人数" class="s-input" v-model="info.requiredSubmitCount">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>单人报价</label>
      <div class="s-form-controller">
        <input type="number" placeholder="请填写活动最低报价" class="s-input" v-model="info.price">~
        <input type="number" placeholder="请填写活动最高报价" class="s-input" v-model="info.maxPrice">
        万元
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>活动内容</label>
      <div class="">
          <textarea  class="s-input s-areatext" type="text" placeholder="请填写活动内容" v-model="info.content"></textarea>
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>截止日期</label>
      <div class="">
          <input  class="s-input" type="date" placeholder="请填写截止日期" v-model="info.submitEndTime">
      </div>
    </div>
  </div>
  <div class="button-box">
    <button class="s-button s-button-primary s-button-block" @click="submit" :class="{'s-button__disabled':isSubmit}">提交</button>
  </div>
</div>
</template>

<script>
import config from '@/utils/config'

export default {
  name: 'taskAdd',
  data () {
    return {
      isSubmit: false,
      info: {}
    }
  },
  methods: {
    submit() {
      if (this.isSubmit) {
        return
      }

      let info = Object.assign({}, this.info)

      if (!info.brandName) {
        return this.$toast.show('品牌名称不能为空')
      }
      if (!info.name) {
        return this.$toast.show('活动名称不能为空')
      }
      if (!info.requiredFansCount) {
        return this.$toast.show('粉丝要求数不能为空')
      }
      if (!info.content) {
        return this.$toast.show('活动描述不能为空')
      }
      if (!info.price) {
        return this.$toast.show('单人报价不能为空')
      }
      if (!info.requiredSubmitCount) {
        return this.$toast.show('活动需要人数不能为空')
      }      
      if (!info.submitEndTime) {
        return this.$toast.show('活动截止日期不能为空')
      }

      info.requiredSubmitCount = parseInt(info.requiredSubmitCount)
      info.requiredFansCount = parseInt(info.requiredFansCount)      
      info.maxFansCount = parseInt(info.maxFansCount)
      info.maxPrice = parseInt(info.maxPrice)*10000
      info.price = parseInt(info.price)*10000

      this.$http.post(`${config.HOST}douyin/v1/task/save`, info).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            this.isSubmit = true
            this.$toast.show('保存成功')
            this.$router.push({
              name: 'taskDetail',
              params: {
                id: data.data.id
              }
            })
          } else {
            this.$toast.show('保存失败')
          }
        },
        response => {
          // error callback
        }
      )
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../info/add.less";
  .s-areatext{
    width: 100%;
    background: #0e0f1a;
    border-radius: 4px;
    padding: 10px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/containers/task/Add.vue